import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, null, -1)
const _hoisted_2 = { class: "main-wrapper" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResourceErrorState = _resolveComponent("ResourceErrorState")!
  const _component_AdminAccommodationInquiryDetails = _resolveComponent("AdminAccommodationInquiryDetails")!
  const _component_AdminAccommodationInquiryFormDialog = _resolveComponent("AdminAccommodationInquiryFormDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading..."))
        : (_ctx.error)
          ? (_openBlock(), _createBlock(_component_ResourceErrorState, {
              key: 1,
              kind: _ctx.error.kind,
              "trace-id": _ctx.error.traceId,
              "back-to": "/admin/accommodationinquiries",
              "back-label": "Vissza a szállásigényekhez",
              onRetry: _ctx.fetchData
            }, null, 8, ["kind", "trace-id", "onRetry"]))
          : (_ctx.isAdmin && _ctx.accommodationInquiry)
            ? (_openBlock(), _createBlock(_component_AdminAccommodationInquiryDetails, {
                key: 2,
                accommodationInquiry: _ctx.accommodationInquiry,
                onOfferCreated: _ctx.refreshData,
                onOfferAccepted: _ctx.refreshData,
                onEditInquiry: _ctx.openEditDialog
              }, null, 8, ["accommodationInquiry", "onOfferCreated", "onOfferAccepted", "onEditInquiry"]))
            : _createCommentVNode("", true),
      (_ctx.isAdmin && _ctx.accommodationInquiry)
        ? (_openBlock(), _createBlock(_component_AdminAccommodationInquiryFormDialog, {
            key: 3,
            mode: "edit",
            show: _ctx.showEditDialog,
            inquiry: _ctx.accommodationInquiry,
            onCloseEditInquiry: _ctx.closeEditDialog,
            onInquiryUpdated: _ctx.onEdited,
            onInquiryConflict: _ctx.onEdited
          }, null, 8, ["show", "inquiry", "onCloseEditInquiry", "onInquiryUpdated", "onInquiryConflict"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}